module.exports = __webpack_public_path__ + "static/media/car1.d410aba5.png";